import { render } from "./taohaohao.vue?vue&type=template&id=09c7f982&scoped=true"
import script from "./taohaohao.vue?vue&type=script&lang=js"
export * from "./taohaohao.vue?vue&type=script&lang=js"

import "./taohaohao.vue?vue&type=style&index=0&id=09c7f982&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c7f982"]])

export default __exports__